exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videos__container__ar8oZ{height:100%}.videos__thumbnail-wrapper__olWOu{position:relative;overflow:hidden}.videos__next-button__1doGS,.videos__prev-button__2BpIN{background-color:rgba(0,0,0,.8)}.videos__next-button__1doGS>svg,.videos__prev-button__2BpIN>svg{width:9px;height:18px}", ""]);

// exports
exports.locals = {
	"container": "videos__container__ar8oZ",
	"thumbnail-wrapper": "videos__thumbnail-wrapper__olWOu",
	"thumbnailWrapper": "videos__thumbnail-wrapper__olWOu",
	"next-button": "videos__next-button__1doGS",
	"nextButton": "videos__next-button__1doGS",
	"prev-button": "videos__prev-button__2BpIN",
	"prevButton": "videos__prev-button__2BpIN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/videos/videos.styl
// module id = 2943
// module chunks = 1